"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
const translation_1 = require("../../../translation");
const constants_1 = require("../../constants");
exports.TYPE = 'testInfoStart';
exports.DEFAULT_VALUE = {
    type: 'start',
    percentage: {
        text: (0, translation_1.t)('elements.testInfoStart.percentage'),
        show: true,
        icon: constants_1.imageValueWithObjectFit,
    },
    attempts: {
        text: (0, translation_1.t)('elements.testInfoStart.attempts'),
        show: true,
        icon: constants_1.imageValueWithObjectFit,
    },
    testTime: {
        text: (0, translation_1.t)('elements.testInfoStart.testTime'),
        show: true,
        icon: constants_1.imageValueWithObjectFit,
    },
    questions: {
        text: (0, translation_1.t)('elements.testInfoStart.questions'),
        show: true,
        icon: constants_1.imageValueWithObjectFit,
    },
};
